module.exports = __webpack_public_path__ + "static/tek-panel-sketch-814754bf4711dfb0cb26e0c999356c3e.jpg";